import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function searchVideoCatalogues(query: object) {
  let searchQuery = getQueryString(query);

  try {
    const resp = await axios.get("/api/videoCatalogue/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getVideoCatalogues() {
  try {
    const resp = await axios.get(
      "/api/videoCatalogue/?pageSize=30&pageNumber=1"
    );
    return resp.data.results;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getVideosByCatalogueId(videoCatalogueId: string) {
  if (!videoCatalogueId) return [];

  try {
    const resp = await axios.get(
      `/api/videoCatalogue/${videoCatalogueId}/videos`
    );
    return resp.data; // Ensure API returns expected data
  } catch (error) {
    console.error("Error fetching videos:", error);
    return [];
  }
}

export async function getVideoCatalogueDetails(videoCatalogueId: string) {
  try {
    const resp = await axios.get(
      `/api/videoCatalogue/${videoCatalogueId}/details`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createVideoCatalogue(newCatalogue: object) {
  try {
    const resp = await axios.put("/api/videoCatalogue/create", newCatalogue);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateVideoCatalogue(updatedCatalogue: object) {
  try {
    const resp = await axios.post(
      `/api/videoCatalogue/update`,
      updatedCatalogue
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateCatalogueMapMarkers(
  catalogueId: string,
  mapMarkerIds: string[]
) {
  try {
    const resp = await axios.post(`/api/videoCatalogue/SetMapMarkers`, {
      catalogueGUID: catalogueId,
      mapMarkerGUIDs: mapMarkerIds,
    });
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateCatalogueVideos(
  catalogueId: string,
  videoIds: string[]
) {
  try {
    const resp = await axios.post(`/api/videoCatalogue/SetVideos`, {
      catalogueGUID: catalogueId,
      videoGUIDs: videoIds,
    });
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
